<div class="absolute inset-0">
    <!-- Main -->
    <div class="flex flex-col flex-auto items-center justify-center h-full p-6 sm:p-10">
        <!-- @formatter:on -->
        <div class="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">Ooops... 404!</div>
        <div class="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-secondary">The page you requested could not be found.</div>
        <a
            class="mt-12 font-medium underline text-primary-500"
            [routerLink]="['/']">
            Back to Dashboard
        </a>
    </div>
</div>
